<template>
  <div class="recipients">
    <RecipientList
      v-if="primaryRecipients.length"
      title="Customer Emails:"
      :recipients="primaryRecipients"
      data-cy="primary-contacts-list"
      :disabled="defaultRecipients.length === 1"
      :error="!!errorMessages.onePrimaryOrAddressRequired"
      @toggle-checked="handleToggleRecipient"
    />
    <RecipientList
      v-if="addressRecipients.length"
      class="mt-4"
      title="Address Emails:"
      :recipients="addressRecipients"
      data-cy="address-contacts-list"
      :error="!!errorMessages.onePrimaryOrAddressRequired"
      @toggle-checked="handleToggleRecipient"
    />
    <div data-cy="additional-recipients-container" class="mt-4">
      <div class="additionalRecipients">
        <div>
          <strong>Additional Emails:</strong>
        </div>
        <AdditionalRecipient
          v-for="(_, index) in additionalRecipients"
          ref="additionalRecipientsElRef"
          :key="index"
          v-model="additionalRecipients[index]"
          data-cy="additional-recipient"
          class="mb-1"
          @remove-recipient="handleRemoveAdditionalRecipient(index)"
        />
      </div>
      <ItemAdder
        v-if="additionalRecipients.length < 10"
        text="Add Email"
        class="adder mr-3 mt-2 mb-2"
        slim
        transparent
        data-cy="add-email"
        @click="handleAddAdditionalRecipient"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import ItemAdder from "@/components/ItemAdder.vue";
import { injectUseEmailQuoteOrInvoice } from "../useEmailQuoteOrInvoice";
import AdditionalRecipient from "./AdditionalRecipient.vue";
import RecipientList from "./RecipientList.vue";

const {
  defaultRecipients,
  primaryRecipients,
  addressRecipients,
  errorMessages,
  additionalRecipientsElRef,
  additionalRecipients,
  handleRemoveAdditionalRecipient,
  handleAddAdditionalRecipient,
  handleToggleRecipient
} = injectUseEmailQuoteOrInvoice();
</script>

<style lang="scss" scoped>
// Adjusting so that the width of Add Email aligns with the textfield
:deep(.adder) {
  width: calc(100% - 40px) !important;
}
</style>
